module.exports = __webpack_public_path__ + "3d11576f4a3db70a6a77b840b97b47df.svg";